import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { Switch, Typography, FormControl, FormControlLabel } from '@mui/material';

class ToggleInputForTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || false
        };
    }

    componentDidMount() {
     const value = false;
     this.setState({ value });
    this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.name });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.value) {
            this.setState({ value: nextProps.value });
        }
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }

    onToggle = (event, value) => {
        if (this.props.onToggleEvent) {
            // console.log(this.props.onToggleEvent(event));
            const shouldProceed = this.props.onToggleEvent(event);
            if (shouldProceed === false) {
                return;  // Prevent state update if parent doesn't allow it
            }
        }

        this.setState({ value });
        this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.name });
    }

    render() {
        const { name, label, disabled, className } = this.props;
        return (
            <div className="form-group">
                <FormControlLabel
                    control={
                        <Switch
                            checked={this.state.value}
                            onChange={this.onToggle}
                            name={name}
                            disabled={disabled}
                            className={className}
                        />
                    }
                    label={label}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name]
    };
};

export default connect(mapStateToProps)(ToggleInputForTable);
